import React from 'react';
import classNames from 'classnames';

type LetterIndicatorProps = {
    className?: string;
    foregroundColor?: string | null;
    letter?: string;
};

const LetterIndicator: React.FC<LetterIndicatorProps> = ({ className, foregroundColor, letter = 'A' }) => {
    const style = {
        ...(foregroundColor ? { color: foregroundColor } : null),
    };

    return (
        <span className={classNames('LetterIndicator', className)} style={style}>
            {letter}
        </span>
    );
};

export default LetterIndicator;
